import React from "react";

import Framework from "@beardeddevops/react.framework";
import {Types} from "components";
import ObjectOverride from "components/ObjectOverride";


/**
 *  @property {Locations_Bound_Books_Object} state
 *  @property {object} model
 *  @property {Locations_Bound_Books_Properties} model.properties
 *  @property {Locations_Bound_Books_Is} model.is
 *  @property {Locations_Bound_Books_Has} model.has
 */
export default class BoundBookAdd extends ObjectOverride {
	constructor(props) {
		super(props, Types.Locations_Bound_Books._name);
	}

	form = () => {
		/** @type {Locations_Bound_Books_Properties} properties */
		let properties = this.model.properties;
		/** @type {Locations_Bound_Books_Object} object */
		let object = this.state;
		let {loading} = this.state;

		return (
			<div>
				<fieldset>
					<div className={"row"}>

						<div className={"col-md"}>
							<h4 className="section-title">Bound Book</h4>

							<div className="form-group">
								<Framework.Elements.TextField
									label={"Bound Book Name"}
									value={object.name}
									error={object.name_error}
									property={properties.name}
									update={this.handleTextFieldPropertyUpdate}
								/>
							</div>

						</div>

					</div>
				</fieldset>

				<Framework.Elements.LoadingSpinner isLoading={loading}/>
			</div>
		)
	};

}
